var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk } from '@reduxjs/toolkit';
import { ViewportActionCreators } from '@printu/viewport';
import { updateScaleMode as updateViewportScaleMode } from 'app/stores/viewport/update';
export const setCanvasRect = createAsyncThunk('viewport/setCanvas', (bounds, { dispatch, getState }) => __awaiter(void 0, void 0, void 0, function* () {
    // call original
    dispatch(ViewportActionCreators.setCanvasRect(bounds));
    // try fixing the scale
    updateViewportScaleMode(dispatch, getState);
}));
